<template>
    <div class="font-weight-bold">
      <b-modal id="price_modal" title="Payment amount information" size="lg" ok-only>
        <b>Payment amount information</b>
        <p>Service price policy. It depends on the usage by number of servers. If you want to change the conditions, you can use the higher service through the service condition change application.</p>
        <p>If you have any questions about the payment amount, please email us at pay@f1security.co.kr and we will review it within 3 business days. </p>
        <b style="font-style: italic;">UWSS Pricing</b>
        <table style="height: 405px; width: 770px; border:1px solid gray;">
          <tbody style="border:1px solid gray;">
            <tr style="height: 25px;" class="a">
              <td class="a" style="width: 399px; height: 25px;" colspan="2"></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id"><b>{{service.service_name}}</b></td>
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 399px; height: 25px;" colspan="2"><b>Price (Monthly Subscription)</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id"><b>$ {{service.base_price}}</b></td>
              <!-- <td class="a" style="width: 119px; height: 25px;">$59</td>
              <td class="a" style="width: 119px; height: 25px;">$159</td>
              <td class="a" style="width: 106px; height: 25px;">$599</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 75px;" rowspan="3"><b>Service Target</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>Number of Web Server</b></td>
              <td class="a" style="width: 119px; height: 50px;" v-for="service in (services || [])" v-bind:key="service.id" rowspan="2">1</td>
              <!-- <td class="a" style="width: 119px; height: 50px;" rowspan="2">1</td>
              <td class="a" style="width: 106px; height: 50px;" rowspan="2">1</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>* Physical or Logical server</b></td>
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>Number of Web Domain</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">
                {{
                service.target_domain > 0 ? (service.target_domain == 1 ? service.target_domain : `1 ~ ${service.target_domain}`) : `${service.target_domain * -1} +`
                }}
              </td>
              <!-- <td class="a" style="width: 119px; height: 25px;">1 ~ 4</td>
              <td class="a" style="width: 106px; height: 25px;">5 +</td> -->
            </tr>
            <!-- 방화벽 -->
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 50px;" rowspan="2"><b>Web Hacking Protection<br>(server)</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>HTTPS/SSL via WAF</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.waf > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>Web Application Firewall</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.waf > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <!-- 웹쉘파인더 -->
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 50px;" rowspan="2"><b>WebShell Protection <br>(server)</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>WebShell Detection & Blocking</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.wsfinder > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 119px; height: 25px;">O</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>WebShell Analysis Support</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.wsfinder_analysis > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 50px;" rowspan="2"><b>Web Malware Protection<br>(domain)</b></td>
              <td class="a" style="width: 200px; height: 25px;"><b>Web Malware distribution Detection</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">
                {{service.wmds_site > 0 ? `O` : 'N/A'}}
                <br>
                <small>{{service.wmds_site > 0 ? `(MAX ${service.wmds_page || 0} pages)` : ''}}</small>
              </td>
              <!-- <td class="a" style="width: 119px; height: 25px;">O<br>(Max 50 pages)</td>
              <td class="a" style="width: 119px; height: 25px;">O<br>(Max 500 pages)</td>
              <td class="a" style="width: 106px; height: 25px;">O<br>(Max 5,000 pages)</td> -->
            </tr>
            <tr class="a" style="height: 25px;">
              <td class="a" style="width: 100px; height: 25px;"><b>Web Malware Analysis Support</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.wmds_analysis > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 119px; height: 25px;">N/A</td>
              <td class="a" style="width: 106px; height: 25px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 100px; height: 26px;"><b>Web Forgery Protection</b></td>
              <td class="a" style="width: 200px; height: 26px;"><b>Web Forgery Detection</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.integrity > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 100px; height: 130px;" rowspan="5"><b>Technical Support</b></td>
              <td class="a" style="width: 200px; height: 26px;"><b>Dedicated Support Team</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.technical_support > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>Agent Installation Support</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.install_support > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>Security Policy Setting Support</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.policy_support > 0 ? `O` : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">O</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
            <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>Email Response</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">24x7x365 <br>{{`within ${service.email_support} hours`}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">24x7x365 <br>within 8 hours</td>
              <td class="a" style="width: 119px; height: 26px;">24x7x365 <br>within 4 hours</td>
              <td class="a" style="width: 106px; height: 26px;">24x7x365 <br>within 2 hours</td> -->
            </tr>
              <tr class="a" style="height: 26px;">
              <td class="a" style="width: 200px; height: 26px;"><b>Phone Response</b></td>
              <td class="a" style="width: 119px; height: 25px;" v-for="service in (services || [])" v-bind:key="service.id">{{service.phone_support > 0 ? 'O' : 'N/A'}}</td>
              <!-- <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 119px; height: 26px;">N/A</td>
              <td class="a" style="width: 106px; height: 26px;">O</td> -->
            </tr>
          </tbody>
        </table>
      </b-modal>
    </div>
</template>
<style>
.a {
  border: 1px solid gray;
  text-align: center;
  font-style: italic;
}
.k {
  /* width : 300px; */
  height: 200px;
}
.g {
  /* width: 33px; */
  height: 100px;
}
.s {
  width: 1075px;
  height: 300px;
}
</style>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>